import Swal from 'sweetalert2';
import { getLifecycleDialogConfig } from './lifecycleMessages.js';

export async function confirmLifecycleAction(action, entityLabel = 'persoon') {
  const config = getLifecycleDialogConfig(action, entityLabel);

  const result = await Swal.fire({
    title: config.title,
    html: config.html,
    icon: config.icon || 'question',
    showCancelButton: true,
    confirmButtonText: config.confirmButtonText || 'OK',
    cancelButtonText: 'Annuleren',
    reverseButtons: true,
    focusCancel: true,
    customClass: {
      popup: 'rounded-3',
      confirmButton: 'btn btn-primary me-2',
      cancelButton: 'btn btn-outline-secondary'
    },
    buttonsStyling: false
  });

  return {
    isConfirmed: result.isConfirmed,
    config
  };
}

export async function showLifecycleSuccess(action, entityLabel = 'persoon', customText = '') {
  const config = getLifecycleDialogConfig(action, entityLabel);

  await Swal.fire({
    title: config.successTitle || 'Gelukt',
    text: customText || config.successText || 'De actie is succesvol uitgevoerd.',
    icon: 'success',
    timer: 1800,
    showConfirmButton: false
  });
}

export async function showLifecycleError(message = 'Er is iets misgegaan.') {
  await Swal.fire({
    title: 'Fout',
    text: message,
    icon: 'error',
    confirmButtonText: 'Sluiten',
    customClass: {
      confirmButton: 'btn btn-danger'
    },
    buttonsStyling: false
  });
}